import { Exclude, Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { WFEPaymentRequestWorkflowItemRawDto } from './wfe-payment-request-workflow-item-raw-dto';

export class PaymentRequestRawDto {
    communityId: number;
    payeeType: string;
    payeeCode: string;
    vendorAccountId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    invoiceDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    dueDate: Date;
    description: string;
    invoiceAmount: number;
    amount: number;
    invoiceNumber: string;
    specialHandlingId: number;
    lateFee: number;
    isEFTAccount: boolean;
    bankAccountId: number;

    @Type(() => WFEPaymentRequestWorkflowItemRawDto)
    items: Array<WFEPaymentRequestWorkflowItemRawDto>;
    specialInstruction: string;
    generatePaymentRequest: boolean;
    fileName: string;
    fileBase64String: string;
    printedOwnerName: string;
    vendorInfo: string;

    // Transient
    @Exclude()
    isVendorAccountMandatory: boolean;
}
